module.exports = __webpack_public_path__ + "static/media/SarahSwitek_05_BodySensations-Confirmation_8.71c6d5bf.mp3";